import { render, staticRenderFns } from "./jieguo.vue?vue&type=template&id=1dde9b5c&scoped=true"
import script from "./jieguo.vue?vue&type=script&lang=js"
export * from "./jieguo.vue?vue&type=script&lang=js"
import style0 from "./jieguo.vue?vue&type=style&index=0&id=1dde9b5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dde9b5c",
  null
  
)

export default component.exports